import { render } from "./ModalViewInc.vue?vue&type=template&id=455b63ce"
import script from "./ModalViewInc.vue?vue&type=script&lang=js"
export * from "./ModalViewInc.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__